import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { emailSchema } from '~/utils/validation';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';
import { KeyboardEvent } from 'react';
import { z } from 'zod';

const schema = z.object({
  email: emailSchema,
});

type Schema = z.infer<typeof schema>;

interface Props {
  onSubmit: (payload: Schema) => void;
}

export function AddAdministratorForm({ onSubmit: parentOnSubmit }: Props) {
  const { formState, register, setValue, handleSubmit } = useForm<Schema>({
    resolver: zodResolver(schema),
  });

  function onSubmit(payload: Schema) {
    parentOnSubmit(payload);
    setValue('email', '');
  }

  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  return (
    <Grid style={{ rowGap: 0 }}>
      <Grid.Item cols={{ sm: 12, lg: 4 }}>
        <Input.Group formState={formState} label="E-post" htmlFor="email">
          <Input.Field onKeyDown={handleKeyDown} {...register('email')} formState={formState} type="email" />

          <Button type="button" variant="secondary" onClick={handleSubmit(onSubmit)}>
            Lägg&nbsp;till
          </Button>
        </Input.Group>
      </Grid.Item>
    </Grid>
  );
}
